import { connect } from "react-redux";
import { selectContentType } from "../../../state/selectors";
import { CONTENT_TYPE_STILL } from "../../../assets/constants";
import { CounterView } from "./Counter";

const mapStateToProps = (state) => ({
    isContentPhoto: selectContentType(state) === CONTENT_TYPE_STILL
});

const mapDispatchToProps = () => ({
});

const Counter = connect(
    mapStateToProps,
    mapDispatchToProps
)(CounterView);

export { Counter };
